// The Settings area's shared chrome: the tab strip. Integrations and Forms
// are staff-readable, the rest is admin chrome. Credential forms (Stripe
// keys and kin) live in the gear dialogs on the Integrations page, not in
// tabs of their own.

import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentUser } from "../../components/auth/CurrentUserContext";
import { isAdminRole } from "../../lib/roles";

const TABS = [
  { path: "/settings/firm", label: "Firm profile", adminOnly: true },
  { path: "/settings/modules", label: "Modules", adminOnly: true },
  { path: "/settings/integrations", label: "Integrations", adminOnly: false },
  { path: "/settings/forms", label: "Forms", adminOnly: false },
  { path: "/settings/email", label: "Email log", adminOnly: true },
];

export function SettingsNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAdmin = isAdminRole(useCurrentUser()?.role);
  const tabs = TABS.filter((t) => isAdmin || !t.adminOnly);
  return (
    <div className="cc-tabs settings-tabs" role="tablist" aria-label="Settings sections">
      {tabs.map((t) => (
        <button
          key={t.path}
          type="button"
          role="tab"
          aria-selected={pathname.startsWith(t.path)}
          className={pathname.startsWith(t.path) ? "active" : undefined}
          onClick={() => navigate(t.path)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
